import LegalPage from "../components/LegalPage";
import { TERMS } from "../content/legal";

export default function Terms() {
  return <LegalPage title="Terms of Service" source={TERMS} />;
}
